import React from 'react';

const ExperienceItem = ({ job }) => (
  <div className="mb-6 last:mb-0 experience-item">
    <div className="flex flex-col md:flex-row justify-between md:items-center mb-1">
      <h4 className="text-lg font-bold text-slate-800">{job.role}</h4>
      <span className="text-sm font-semibold text-blue-700 bg-blue-50 px-3 py-1 rounded-full w-fit mt-2 md:mt-0">
        {job.period}
      </span>
    </div>
    <div className="text-md font-medium text-slate-600 mb-2">
      {job.company} {job.location && <span className="text-slate-500 italic">| {job.location}</span>}
    </div>
    <ul className="list-disc list-outside ml-5 text-slate-700 space-y-2 text-sm leading-relaxed">
      {job.highlights.map((highlight, index) => (
        <li key={index} className="pl-1 text-justify">
          {highlight}
        </li>
      ))}
    </ul>
  </div>
);

const AdditionalExperienceItem = ({ job }) => (
  <div className="mb-4 last:mb-0 experience-item">
    <div className="flex flex-col md:flex-row justify-between md:items-center mb-1">
      <h4 className="text-md font-bold text-slate-800">
        {job.company} <span className="font-medium text-slate-600">| {job.role}</span>
      </h4>
      <span className="text-sm font-semibold text-slate-600 mt-1 md:mt-0">
        {job.period}
      </span>
    </div>
    <ul className="list-disc list-outside ml-5 text-slate-700 space-y-1 text-sm leading-relaxed">
      <li className="pl-1 text-justify">{job.bullet}</li>
    </ul>
  </div>
);

const ResumeExperience = ({ experience, additionalExperience }) => {
  return (
    <section className="mb-8">
      <h3 className="text-lg font-bold text-slate-900 uppercase tracking-wider border-b-2 border-slate-200 pb-2 mb-5">
        Professional Experience
      </h3>
      <div className="space-y-6 mb-6">
        {experience.map((job, index) => (
          <ExperienceItem key={index} job={job} />
        ))}
      </div>

      {additionalExperience && additionalExperience.length > 0 && (
        <div className="mt-8 pt-4 border-t border-slate-100">
          <h4 className="text-[15px] font-bold text-slate-800 uppercase tracking-wider mb-4">
            Additional Graphic & Pre-Press Experience (1998–2015)
          </h4>
          <div className="space-y-4">
            {additionalExperience.map((job, index) => (
              <AdditionalExperienceItem key={index} job={job} />
            ))}
          </div>
        </div>
      )}
    </section>
  );
};

export default ResumeExperience;